import { fixMojibake } from './utils'

// El historico del grupo por temporada (objetivo 3 del spec de torneos internos).
//
// De un torneo INTERNO la temporada es la del torneo: el torneo es del club y desde
// 2026-09-05 es obligatoria. (La temporada de un torneo de la RED es otra cosa -- es
// contabilidad interna del club, no del torneo -- y se resuelve aparte, manana.)
export const SIN_TEMPORADA = 'sin_temporada'

const temporadaDe = (torneo) => torneo?.temporadas || torneo?.temporada || null

// Agrupa una lista de torneos por su temporada: la mas reciente arriba (por fecha de
// inicio de la temporada), y "Sin temporada" SIEMPRE al final, con sus torneos. No se
// esconde nada: un torneo sin temporada es un dato que falta, y hay que verlo para
// arreglarlo. Dentro de cada grupo, los torneos van del mas reciente al mas viejo.
export const agruparPorTemporada = (torneos = []) => {
  const grupos = new Map()
  ;(torneos || []).forEach((torneo) => {
    if (!torneo) return
    const t = temporadaDe(torneo)
    const clave = t?.id || SIN_TEMPORADA
    if (!grupos.has(clave)) {
      grupos.set(clave, {
        id: clave,
        nombre: t?.id ? fixMojibake(t.nombre || 'Temporada') : 'Sin temporada',
        fecha_inicio: t?.fecha_inicio || null,
        estado: t?.estado || null,
        torneos: [],
      })
    }
    grupos.get(clave).torneos.push(torneo)
  })
  const porFecha = (a, b) => (b.fecha_inicio || '').localeCompare(a.fecha_inicio || '')
  return Array.from(grupos.values())
    .map((g) => ({ ...g, torneos: [...g.torneos].sort(porFecha) }))
    .sort((a, b) => {
      if (a.id === SIN_TEMPORADA) return 1
      if (b.id === SIN_TEMPORADA) return -1
      return porFecha(a, b)
    })
}
